import { trpc } from '@web/lib/trpc';
import { useState } from 'react';
export var useRecurringMeetings = function (meetingId, isRecurring) {
    var _a = useState([]), recurringMeetings = _a[0], setRecurringMeetings = _a[1];
    var currentIndex = recurringMeetings.findIndex(function (m) { return m.id === meetingId; });
    var isFirstMeeting = currentIndex === 0;
    var isLastMeeting = currentIndex === recurringMeetings.length - 1;
    var shouldFetch = isRecurring &&
        (recurringMeetings.length === 0 || isFirstMeeting || isLastMeeting);
    trpc.getRecurringMeetings.useQuery({ meetingId: meetingId }, {
        enabled: shouldFetch,
        onSuccess: function (data) {
            if (!data)
                return;
            setRecurringMeetings(data);
        }
    });
    return {
        recurringMeetings: recurringMeetings
    };
};
